import { render } from "./IconImage.vue?vue&type=template&id=7427df16"
import script from "./IconImage.vue?vue&type=script&lang=js"
export * from "./IconImage.vue?vue&type=script&lang=js"
script.render = render

export default script